// var exports = {};
/***********************************************

 @Author S.Harsini
 ***********************************************/
Object.defineProperty(exports, "__esModule", {
  value: true
});
const _createClass = (function() {
  function defineProperties(target, props) {
    for (let i = 0; i < props.length; i++) {
      const descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}());

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

const _extends = Object.assign || function(target) {
  for (let i = 1; i < arguments.length; i++) {
    const source = arguments[i];
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

const ERROR_UNAUTHORIZED = "invalid_token";
const STATUS_OK = 200;
const STATUS_UNAUTHORIZED = 401;
const STATUS_FORBIDDEN = 403;

const reqByAuth = (function() {
  function reqByAuth(obj) {
    _classCallCheck(this, reqByAuth);
    this.tokens = {
      refreshToken: null,
      accessToken: null,
      user: null,
	  lastLogin : null, 
	  authorities : null
    };
    this.endpoint = {
      url: null,
      method: "GET",
      body: null
    };
    this.httpreq = this.httpreq.bind(this);
    this.httpreqAfterInvalidToken = this.httpreqAfterInvalidToken.bind(this);
    this.renewToken = this.renewToken.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.clear = this.clear.bind(this);
    this.loadTokens = this.loadTokens.bind(this);
  }

  _createClass(reqByAuth, [
    {
      key: "httpreq",
      value: function httpreq(endpoint) {
        const _this = this;
        this.loadTokens();
        this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });
        return fetch(this.endpoint.url, {
          method: this.endpoint.method,
          headers: new Headers({
			  "Authorization": "Bearer " + this.tokens.accessToken,
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(this.endpoint.body)
        }).then(response =>
          response.json().then(data => ({
            data: data,
            status: response.status,
			response : response
          }))).then(res => {
          if (res.status === STATUS_FORBIDDEN) {
            return this.clear().then(risp => risp);
          } else if (res.status !== STATUS_OK && res.status === STATUS_UNAUTHORIZED && res.data.error === ERROR_UNAUTHORIZED) {
            return this.renewToken().then(r => {
              if (r.data.access_token != null) {
                _this.authenticate({ refreshToken: r.data.refresh_token, accessToken: r.data.access_token });
                return this.httpreqAfterInvalidToken(this.endpoint.url).then(risp => risp);
              } else {
                const msg = {};
				this.clear()
                Object.assign(msg, { "type": r.status, "payload": r.data });
                console.log(msg);
                return [];
              }
            });
          } else {
            return res;
          }
        }).catch(err => console.log(err));
      }
    }, {
      key: "httpreqFile",
      value: function httpreqFile(endpoint) {
        const _this = this;
        this.loadTokens();
        this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });
        return fetch(this.endpoint.url, {
          method: this.endpoint.method,
          headers: new Headers({
            "Authorization": "Bearer " + this.tokens.accessToken,
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(this.endpoint.body)
        }).then(response => {
          return {
            data: response.blob(),
            status: response.status
          };
        }).then(res => {
          if (res.status === STATUS_UNAUTHORIZED) {
            return this.renewToken().then(r => {
              if (r.data.access_token != null) {
                _this.authenticate({ refreshToken: r.data.refresh_token, accessToken: r.data.access_token });
                return this.httpreqFilez(this.endpoint.url).then(risp => risp);
              } else {
                const msg = {};
                Object.assign(msg, { "type": r.status, "payload": r.data });
                console.log(msg);
                return [];
              }
            });
          } else if (res.status === 500 || res.status === 406) {
				  return {status : res.status, data : res.data};			  
			  } else {
            return {status : res.status, data : res.data};	
          }
        }).catch(err => console.log(err));
      }
    }, {
      key: "httpreqFilez",
      value: function httpreqFilez(endpoint) {
        const _this = this;
        /*this.loadTokens();*/
        /*this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });*/
        return fetch(endpoint, {
          method: this.endpoint.method,
          headers: new Headers({
            "Authorization": "Bearer " + this.tokens.accessToken,
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(this.endpoint.body)
        }).then(response =>
          response.then(data => ({
            data: data,
            status: response.status
          }))).then(res => {
          if (res.status === STATUS_UNAUTHORIZED) {
            return this.renewToken().then(r => {
              if (r.data.access_token != null) {
                _this.authenticate({ refreshToken: r.data.refresh_token, accessToken: r.data.access_token });
                return this.httpreqFile(this.endpoint.url).then(risp => risp);
              } else {
                const msg = {};
                Object.assign(msg, { "type": r.status, "payload": r.data });
                console.log(msg);
                return [];
              }
            });
          } else if (res.status === 500 || res.status === 406) {
				  return {status : res.status, data : res.data};	  
			  } else {
            return {status : res.status, data : res.data};
          }
        }).catch(err => console.log(err));
      }
    },
    {
      key: "httpreqAfterInvalidToken",
      value: function httpreqAfterInvalidToken(endpoint) {
        const _this = this;
        /*this.loadTokens();*/
        /*this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });*/
        return fetch(endpoint, {
          method: this.endpoint.method,
          headers: new Headers({
            "Authorization": "Bearer " + this.tokens.accessToken,
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(this.endpoint.body)
        }).then(response =>
          response.json().then(data => ({
            data: data,
            status: response.status,
			response: response
          }))).then(res => {
          if (res.status !== STATUS_OK && res.status === STATUS_UNAUTHORIZED && res.data.error === ERROR_UNAUTHORIZED) {
            return this.renewToken().then(r => {
              if (r.data.access_token != null) {
                _this.authenticate({ refreshToken: r.data.refresh_token, accessToken: r.data.access_token });
                return this.httpreq(this.endpoint.url).then(risp => risp);
              } else {
                const msg = {};
                Object.assign(msg, { "type": r.status, "payload": r.data });
                console.log(msg);
				this.clear()
                return [];
              }
            });
          } else {
            return res;
          }
        }).catch(err => console.log(err));
      }
    },
    {
      key: "renewToken",
      value: function renewToken() {
        return fetch("/oauth/token", {
          method: "POST",
          headers: new Headers({
            "Authorization": "Basic cG9ydGFsV2ViQXBwOnNlY3JldA==",
            "Content-Type": "application/x-www-form-urlencoded"
          }),
          body: "grant_type=refresh_token&client_id=portalWebApp&refresh_token=" + this.tokens.refreshToken
        }).then(response =>
          response.json().then(data => ({
            data: data,
            status: response.status
          }))).then(res => res).then(res => {
            return res;
          }
        );
      }
    },
    {
      key: "authenticate",
      value: function authenticate(auth) {
        if (auth.accessToken !== undefined) {
          this.tokens = _extends({}, this.tokens, { refreshToken: auth.refreshToken, accessToken: auth.accessToken, user : auth.user, lastLogin : auth.lastLogin,  authorities : auth.authorities });
          window.name = JSON.stringify(this.tokens);
        }
      }
    },
    {
      key: "loadTokens",
      value: function loadTokens() {
        if (window.name !== "") {
          const obj = JSON.parse(window.name);
          this.tokens = _extends({}, this.tokens, { refreshToken: obj.refreshToken, accessToken: obj.accessToken, user : obj.user, lastLogin : obj.lastLogin, authorities : obj.authorities });
        } else {
          this.tokens = _extends({}, this.tokens, { refreshToken: null, accessToken: null, user : null, lastLogin : null,  authorities : null });
        }
      }
    },
    {
      key: "lastLogin",
      value: function lastLogin() {
        if (window.name !== "") {
          const obj = JSON.parse(window.name);
          return obj.lastLogin;
        } else {
          return "N/A";
        }
      }
    },
    {
      key: "clear",
      value: function clear() {
        this.tokens = _extends({}, this.tokens, { refreshToken: null, accessToken: null, user : null, lastLogin : null,  authorities : null });
        window.name = "";
        window.location = "/";
      }
    },
    {
      key: "isAuth",
      value: function isAuth() {
        this.loadTokens();
        if (this.tokens.accessToken !== null) {
          return true; //
        } else {
          return false;
        }

      }
    },
{
      key: "httpreqAuth",
      value: function httpreqAuth(endpoint) {
        const _this = this;
        this.loadTokens();
        this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });
        return fetch(this.endpoint.url, {
          method: this.endpoint.method,
          headers: new Headers({
            "Authorization": 'Basic cG9ydGFsV2ViQXBwOnNlY3JldA==',
			'Content-Type': 'application/x-www-form-urlencoded',
			Accept: 'application/json, text/plain, */*',
			pragma: 'no-cache',
			'cache-control': 'no-cache',
			Application: 'portal',
			Env: 'dev',
			'Client-Version': '0.1',
			Channel: 'web',
			Locale: 'it'
          }),
          body: this.endpoint.body
        }).then(response =>
          response.json().then(data => ({
            data: data,
            status: response.status,
			response : response
          }))).then(res => {
          if (res.status === STATUS_FORBIDDEN) {
            return this.clear().then(risp => risp);
          } else if (res.status !== STATUS_OK && res.status === STATUS_UNAUTHORIZED && res.data.error === ERROR_UNAUTHORIZED) {
            return this.renewToken().then(r => {
              if (r.data.access_token != null) {
                _this.authenticate({ refreshToken: r.data.refresh_token, accessToken: r.data.access_token });
                return this.httpreqAfterInvalidToken(this.endpoint.url).then(risp => risp);
              } else {
                const msg = {};
				this.clear()
                Object.assign(msg, { "type": r.status, "payload": r.data });
                console.log(msg);
                return [];
              }
            });
          } else {
            this.authenticate({ refreshToken: res.data.refresh_token, accessToken: res.data.access_token, user : res.data.user, authorities : res.data.authorities[0] });
			window.location = "/SintesiPortafoglio";
			return res.data;
          }
        }).catch(err => console.log(err));
      },
    },
{
      key: "httpreqEmail",
      value: function httpreqEmail(endpoint) {
        const _this = this;
        this.loadTokens();
        this.endpoint = _extends({}, this.endpoint, {
          url: endpoint.url,
          method: endpoint.method,
          body: endpoint.body
        });
        return fetch(this.endpoint.url, {
          method: this.endpoint.method,
          headers: new Headers({
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(this.endpoint.body)
        }).then(response =>
          response.json().then(data => ({
            data: data,
            status: response.status,
			response : response
          }))).then(res => {
          if (res.status === STATUS_FORBIDDEN) {
            return this.clear().then(risp => risp);
          } else if (res.status !== STATUS_OK && res.status === STATUS_UNAUTHORIZED && res.data.error === ERROR_UNAUTHORIZED) {
			return res;
          } else {
            return res;
          }
        }).catch(err => console.log(err));
      }
    }

  ]);

  return reqByAuth;
}());

exports.default = reqByAuth;
